var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods"},[_c('van-swipe',{staticClass:"goods-swipe",attrs:{"autoplay":3000}},_vm._l((_vm.images.thumb),function(thumb){return _c('van-swipe-item',{key:thumb},[_c('img',{attrs:{"src":thumb}})])}),1),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }